
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.603 10.713l.451-.446a.738.738 0 00.15-.191c-.355-.023-.718-.19-1.02-.493-.717-.717-.712-1.736 0-2.453l1.922-1.917c.712-.717 1.732-.721 2.449-.005.721.726.721 1.745.004 2.457l-.86.852c.092.335.092.693.032 1.038l1.392-1.401c1.02-1.02 1.028-2.471-.005-3.509-1.033-1.033-2.486-1.024-3.505-.004L6.616 6.637c-1.02 1.019-1.029 2.471.005 3.504.297.303.637.503.982.572zm-3.72 2.169c1.034 1.033 2.486 1.024 3.51 0l1.993-1.992c1.024-1.024 1.033-2.475 0-3.509-.303-.302-.643-.497-.983-.572l-.46.46a.76.76 0 00-.14.182c.354.024.717.191 1.02.494.716.716.711 1.735-.005 2.452L6.9 12.314c-.712.717-1.736.722-2.449.005-.717-.73-.721-1.74-.004-2.457l.86-.856a2.275 2.275 0 01-.032-1.034L3.883 9.37c-1.024 1.023-1.038 2.475 0 3.513z","fill":"#000C1F"}})])
          )
        }
      }
    